import React, { useEffect, useState, useContext} from 'react'
import DashboardLayout from '../../layoutcontainers/DashboardLayout'
import MaterialDataGrid from '../../components/MaterialDataGrid'
import MaterialTypography from '../../components/MaterialTypography'
import { Card, CardHeader, Stack } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import MaterialButton from '../../components/MaterialButton'
import AddIcon from '@mui/icons-material/Add';
import { CheckCircle, Error, Info } from '@mui/icons-material'
import axios from 'axios';
import BASEURL from '../Utils/Baseurl';
import { useMaterialUIController } from '../../context';
import UserDetailsContext from '../../context/auth';


const WeekOff = () => {

    const navigate = useNavigate()
    const { user,AccessData } = useContext(UserDetailsContext);
    const id = user?.id;
    const [controller, dispatch] = useMaterialUIController()
    const { userAuthenticated } = controller

    const [pageState, setPageState] = useState({
        loading: false,
        error: false,
        message: "",
        state: 'init'
    })

    const [weekoffList, setWeekoffList] = useState([]);

useEffect(()=>{
console.log("weekoffList",weekoffList);

},[])
    const weekoffListTable = {
        columns: [
            {
                field: "location",
                headerName: "Location",
                flex: 1,
                disableColumnMenu: true,
                editable: false,
                sortable: true,
            },
            {
                field: "weekoffDays",
                headerName: "Week Off",
                flex: 1,
                editable: false,
                disableColumnMenu: true,
                sortable: true,
            },
            {
                field: "startDate",
                headerName: "Valid From",
                flex: 1,
                disableColumnMenu: true,
                editable: false,
                sortable: true,
            },
            {
                field: "endDate",
                headerName: "Valid Till",
                flex: 1,
                disableColumnMenu: true,
                editable: false,
                sortable: true,
            },

        ],
        row: weekoffList?.slice().reverse().map(weekoff => {
            console.log('weekoff:',weekoff)
            return (
                {
                    id: weekoff.id,
                    location: weekoff.location,
                    startDate: weekoff.startDate,
                    endDate: weekoff.endDate,
                    weekoffDays: weekoff.weekoffDays,

                }
            )
        }
        )

    }

    useEffect(() => {
        getWeekoffList();
    }, []);


    const getWeekoffList = async () => {
        const query = `    query{
  allWeekoff{
    id
    location
    weekoffDays
    startDate
    endDate
  }
}
`;

        try {
            setPageState({ ...pageState, loading: true });

            const response = await axios.post(BASEURL, {
                query: query
            }, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            console.log('response:', response.data)

            const weekoffList = response.data.data.allWeekoff;
            setWeekoffList(weekoffList);
            setPageState({ ...pageState, loading: false, state: 'success' });

            console.log('Response:', weekoffList);
        } catch (error) {
            console.error('ResponseError:', error);
            setPageState({ ...pageState, loading: false, error: true, message: error.message });
        }
    };



    const handleNewWeekoff = () => {
        navigate('/weekoff/add-weekoff')
    }

    const weekoffListClick = (e) => {
        console.log('weekoffListClick:', e?.id, e)
        if (e?.id) {
            // navigate(`/weekoff/Viewscreen?id=${e?.id}`)
            navigate(`/weekoff/weekoff-details?id=${e?.id}`)
        }
    }

    return (
        <DashboardLayout>
            <Card >
                <CardHeader title={(
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={2}
                    >
                        <Stack direction="column" spacing={0}>
                            <MaterialTypography variant="h5" fontWeight="medium">
                                WeekOff List
                            </MaterialTypography>
                            {/* <MaterialTypography variant="caption" color="text">
                                List of weekoff that you can get details of weekoff.
                            </MaterialTypography> */}
                        </Stack>
                        {AccessData &&
                Array.isArray(AccessData) &&
                AccessData.some(
                  (item) =>
                    item.component === "AddWeekOff" && item.can_access
                ) && (
                        <MaterialButton
                            variant="gradient"
                            color="dark"
                            size="small"
                            startIcon={<AddIcon />}
                            onClick={() => handleNewWeekoff()}
                        >
                            Week Off
                        </MaterialButton>
                )}
                    </Stack>


                )} />
                <MaterialDataGrid
                    customHeight={500}
                    rows={weekoffListTable.row}
                    columns={weekoffListTable.columns}
                    checkboxSelection={false}
                    isSelectable={false}
                    onRowClick={weekoffListClick}
                    loading={pageState.loading}
                    localeText={{
                        noRowsLabel: (
                            <Stack direction="column" alignItems="center" justifyContent="center" spacing={1}>
                                <MaterialTypography variant="body2" fontWeight="medium" color="text">
                                    No Weekoff  found
                                </MaterialTypography>
                                <MaterialTypography variant="caption" color="text">
                                    You have not yet add any weekoff details. Click on the "Add weekoff " button to start adding weekoff.
                                </MaterialTypography>
                            </Stack>
                        )
                    }}
                />
            </Card>
        </DashboardLayout>
    )
}

export default WeekOff
